<template>
    <div
        class="modal"
        v-bind:class="[{ 'is-active': showModal }, modalStyleClass]"
    >
        <div class="modal-background"></div>
        <div
            class="modal-card"
            :class="[{ 'h-full': isFullHeight }, cardStyleClass]"
        >
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="$emit('update:showModal',false)"
                ></button>
            </header>
            <slot name="body-top"></slot>
            <section
                class="modal-card-body"
                :style="{paddingVertical: '0 !important'}"
            >
                <slot name="body"></slot>
            </section>
            <footer
                v-if="showFooter"
                class="modal-card-foot"
                :class="!showSubmitBtn ? 'flex justify-center' : ''"
            >
                <button
                    :class="`btn btn-${submitBtn.type} mr-2`"
                    @click="$emit('submit')"
                    v-if="showSubmitBtn"
                >{{submitBtn.text}}</button>
                <slot name="footer-additional-button"></slot>
                <button
                    :class="`btn btn-${cancelBtn.type}`"
                    @click="$emit('update:showModal',false)"
                >{{cancelBtn.text}}</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        submitBtn: {
            type: Object,
            default: function() {
                return {
                    text: "Submit",
                    type: "success"
                };
            }
        },
        cancelBtn: {
            type: Object,
            default: function() {
                return {
                    text: "Cancel",
                    type: "blank"
                };
            }
        },
        showModal: Boolean,
        showFooter: {
            type: Boolean,
            default: true
        },
        title: String,
        isFullHeight: {
            type: Boolean,
            default: false
        },
        cardStyleClass: String,
        modalStyleClass: String,
        showSubmitBtn: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {};
    }
};
</script>

<style>
.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
